import React, { PureComponent } from 'react'
import Auth from '../../Auth'
import Payment from '../../components/Payment/Payment'
import { Elements, StripeProvider } from 'react-stripe-elements';
import { Pane, Heading, Text, TextInput, Dialog, Tooltip, toaster, Position } from 'evergreen-ui'
import { SaveTwoTone, EditTwoTone, CreditCardTwoTone } from '@ant-design/icons';
import { Button, Layout } from "antd";
import Title from 'antd/lib/typography/Title';
import Datafetcher from '../../utils/datafetcher';
import { User } from '../../types';

const { Content } = Layout;

interface Props {
  datafetcher: Datafetcher
  user: User
}

interface State {
  width : number
  height: number
  nPassword: string
  name: string
  email: string
  passwordModal: boolean
  oPassword: string
  changeCard: boolean
}

export default class componentName extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      width: 0,
      height: 0,
      nPassword: "",
      name: "",
      email: "",
      passwordModal: false,
      oPassword: "",
      changeCard: false
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  isMobile = () => {
    return this.state.width < 640
  }

  changePassword = () => {
    if (!this.state.nPassword || this.state.nPassword.length < 8) {
      toaster.danger("Password must be atleast 8 characters long.")
      return
    }

    this.props.datafetcher.changePassword(this.state.oPassword, this.state.nPassword, (err, res) => {
      if (err) {
        toaster.danger("Something went wrong. Are you sure the password is correct?")
      } else {
        toaster.success("Password changed!")
      }
    })
  }

  changeUserInfo = () => {
    if (!this.state.name) {
      toaster.danger("Name shouln't be blank.")
      return
    }
    if (!this.state.email) {
      toaster.danger("Email shouln't be blank.")
      return
    }
    this.props.datafetcher.changeUserInfo(this.state.email, this.state.name, (err, res) => {
      if (err) {
        toaster.danger("Something went wrong.")
      } else {
        toaster.success("Information updated!")
        setTimeout(function () {
          (new Auth()).logout()
        }, 1000);

      }
    })
  }

  getEmail = () => {
    if (this.state.email !== undefined) {
      return this.state.email
    } else {
      this.setState({ email: this.props.user.email })
      return this.props.user.email
    }
  }

  getName = () => {
    if (this.state.name !== undefined) {
      return this.state.name
    } else {
      this.setState({ name: this.props.user.name })
      return this.props.user.name
    }
  }

  render() {
    return (
      <Layout className="site-layout">
        <Dialog
          isShown={this.state.passwordModal}
          title="Change password"
          width={"fit-content"}
          hasFooter={false}
          onCloseComplete={() => this.setState({ passwordModal: false })}
        >
          <Pane
            display="flex"
            flexDirection="column"
            justifyContent="left">
            <TextInput marginBottom={20} placeholder="Old Password" type="password" value={this.state.oPassword} onChange={(e: any) => this.setState({ oPassword: e.target.value })} />
            <TextInput marginBottom={20} placeholder="New Password" type="password" value={this.state.nPassword} onChange={(e: any) => this.setState({ nPassword: e.target.value })} />
            <Pane
              display="flex"
              flexDirection="row"
              justifyContent="center">
              <Pane>
                <Button shape={"round"} onClick={this.changePassword}>
                  <SaveTwoTone />
                </Button>
              </Pane>
            </Pane>
          </Pane>
        </Dialog>

        <Dialog
          isShown={this.state.changeCard}
          onCloseComplete={() => this.setState({ changeCard: false })}
          hasFooter={false}
          hasHeader={false}
        >
          <StripeProvider apiKey="pk_live_Nx9uvyFtaguBsFe91W2qTyt100OtAAjWrq">
            <Pane padding={40} className="example">
              <Heading marginBottom={0} size={800}>Payment information</Heading>
              <Elements>
                <Payment user={this.props.user} datafetcher={this.props.datafetcher} />
              </Elements>
            </Pane>
          </StripeProvider>
        </Dialog>


        <Content
          className="site-layout-background"
          style={{
            margin: '24px 16px',
            padding: 6,
            minHeight: 280,
          }}
        >
          <Pane display="flex" flexDirection="column" justifyContent="center" clearfix>
            <Pane display="flex" flexDirection="row" justifyContent="center">
              <Pane
                elevation={0}
                float="left"
                backgroundColor="white"
                width={this.isMobile() ? "95%" : "50%"}
                margin={12}
                padding={25}
                paddingTop={25}
                borderRadius={5}
                display="flex"
                flexDirection="column"
                overflow="scroll">
                <Title level={2}>Profile</Title>
                <Pane borderBottom="1px solid #E4E7EB" marginLeft={-30} marginRight={-30} marginTop={15} marginBottom={25}></Pane>
                <Pane
                  display="flex"
                  flexDirection="row"
                  justifyContent="left">
                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Text paddingTop={6} marginBottom={20}>Email</Text>
                    <Text paddingTop={13} marginBottom={20}>Name</Text>
                  </Pane>
                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Tooltip position={Position.TOP} appearance="card" content="If you change your email, you will have to reauthenticate.">
                      <TextInput marginLeft={60} marginBottom={20} placeholder="Email" value={this.getEmail()} onChange={(e:any) => this.setState({ email: e.target.value })} />
                    </Tooltip>
                    <TextInput marginLeft={60} marginBottom={20} placeholder="Name" value={this.getName()} onChange={(e:any) => this.setState({ name: e.target.value })} />
                  </Pane>
                </Pane>
                <Pane><Button shape={"round"} onClick={this.changeUserInfo} ><SaveTwoTone /></Button></Pane>
                <Pane borderBottom="1px solid #E4E7EB" marginLeft={-30} marginRight={-30} marginTop={25} marginBottom={25}></Pane>
                <Pane
                  display="flex"
                  flexDirection="row"
                  justifyContent="left">
                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Text paddingTop={6} marginBottom={20}>Password</Text>
                  </Pane>
                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Button
                      shape={"round"}
                      style={{ marginLeft: 10, marginTop: 1 }}
                      onClick={() => { this.setState({ passwordModal: true }) }}
                      >
                      <EditTwoTone />
                    </Button>
                  </Pane>
                </Pane>
              </Pane>
            </Pane>

            <Pane display="flex" flexDirection="row" justifyContent="center">
              <Pane
                elevation={0}
                float="left"
                backgroundColor="white"
                width={this.isMobile() ? "95%" : "50%"}
                margin={12}
                padding={25}
                paddingTop={25}
                borderRadius={5}
                display="flex"
                flexDirection="column"
                overflow="scroll">
                <Heading marginLeft={-30} marginRight={-30} borderBottom="1px solid #E4E7EB" paddingLeft={30} paddingRight={30} paddingBottom={30} size={600}>Subscription</Heading>
                <Pane
                  marginTop={30}
                  display="flex"
                  flexDirection="row"
                  justifyContent="left">
                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Text paddingTop={6} marginBottom={20}>Current Payment</Text>
                  </Pane>

                  <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="left">
                    <Button
                      shape={"round"}
                      onClick={() => this.setState({ changeCard: true })}
                      style={{ marginLeft: 10, marginTop: 1 }}
                    >
                      <CreditCardTwoTone />
                    </Button>
                  </Pane>

                </Pane>
              </Pane>
            </Pane>
          </Pane>
        </Content>
      </Layout>
    )
  }
}
